// src/components/PlaceOptionOrderCard2.jsx
import { useState } from "react";
import api from "../utils/api";

export default function PlaceOptionOrderCard({ userId, selection }) {
    const [side, setSide] = useState("buy_to_open");
    const [qty, setQty] = useState(1);
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);

    if (!selection) return null;

    const place = async () => {
        if (!userId) {
            alert("Please log in and connect Tradier first.");
            return;
        }

        try {
            setLoading(true);
            setMsg("");

            const body = {
                user_id: userId,
                underlying: selection.symbol,              // AAPL
                expiration: selection.expiration,         // YYYY-MM-DD
                right: String(selection.right || "").toLowerCase(), // call/put
                strike: Number(selection.strike),
                quantity: Number(qty),
                side,                                     // buy_to_open, sell_to_close, etc.
            };

            const { data } = await api.post(
                "/api/trade/quick/option",
                body
            );

            if (data?.ok) {
                setMsg(
                    `Order sent for ${selection.symbol} ${body.right.toUpperCase()} ${body.strike} (${side}, x${body.quantity}).`
                );
            } else {
                const errMsg =
                    data?.error ||
                    data?.message ||
                    JSON.stringify(data || {});
                setMsg(`Order failed: ${errMsg}`);
            }
        } catch (e) {
            console.error("PlaceOptionOrderCard error", e);
            const apiErr = e?.response?.data;
            const errMsg =
                apiErr?.detail ||
                apiErr?.error ||
                apiErr?.message ||
                e?.message ||
                "Request failed.";
            setMsg(`Order failed: ${errMsg}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mt-4 p-4 rounded-2xl bg-zinc-900 border border-zinc-700 space-y-3">
            <div className="flex items-center justify-between">
                <div>
                    <div className="text-sm text-zinc-400">
                        Selected Contract
                    </div>
                    <div className="text-lg font-semibold text-white">
                        {selection.symbol} {selection.right?.toUpperCase()}{" "}
                        {selection.strike} � {selection.expiration}
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm">
                {/* Side */}
                <div className="flex flex-col gap-1">
                    <label className="text-xs text-zinc-400">
                        Side (Tradier)
                    </label>
                    <select
                        value={side}
                        onChange={(e) => setSide(e.target.value)}
                        className="bg-zinc-800 rounded-lg px-3 py-2 border border-zinc-700 text-zinc-100"
                    >
                        <option value="buy_to_open">Buy to Open</option>
                        <option value="sell_to_close">Sell to Close</option>
                        <option value="sell_to_open">Sell to Open</option>
                        <option value="buy_to_close">Buy to Close</option>
                    </select>
                </div>

                {/* Quantity */}
                <div className="flex flex-col gap-1">
                    <label className="text-xs text-zinc-400">Quantity</label>
                    <input
                        type="number"
                        min="1"
                        value={qty}
                        onChange={(e) => setQty(e.target.value)}
                        className="bg-zinc-800 rounded-lg px-3 py-2 border border-zinc-700 text-zinc-100"
                    />
                </div>

                {/* Expiration / Strike summary */}
                <div className="flex flex-col gap-1">
                    <label className="text-xs text-zinc-400">
                        Contract
                    </label>
                    <div className="text-sm text-zinc-200">
                        {selection.right?.toUpperCase()} � Strike{" "}
                        {selection.strike} � Exp{" "}
                        {selection.expiration}
                    </div>
                </div>
            </div>

            <button
                onClick={place}
                disabled={loading}
                className="mt-2 inline-flex items-center justify-center px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 text-sm font-semibold text-white shadow disabled:opacity-60 disabled:cursor-not-allowed"
            >
                {loading ? "Sending�" : "Place Option Order"}
            </button>

            {msg && (
                <div className="text-xs text-zinc-300 mt-2 break-words">
                    {msg}
                </div>
            )}
        </div>
    );
}
